import React from 'react';
import { motion } from 'framer-motion';
import { Globe, Cpu, Database, Shield, Zap } from 'lucide-react';
import './TechFlow.css';

const TechFlow = () => {
  const nodes = [
    { id: 'request', icon: <Globe size={24} />, label: 'User Request', sub: 'Global Edge' },
    { id: 'logic', icon: <Cpu size={24} />, label: 'Neural Engine', sub: 'Business Logic' },
    { id: 'security', icon: <Shield size={24} />, label: 'Auth & Security', sub: 'Encryption' },
    { id: 'data', icon: <Database size={24} />, label: 'Scalable DB', sub: 'Persistent Layer' }
  ];

  return (
    <div className="tech-flow-visual">
      <div className="tf-container">
        {nodes.map((node, index) => (
          <React.Fragment key={node.id}>
            <motion.div 
              className="tf-node"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
            >
              <div className="node-icon-wrapper">
                {node.icon}
                <div className="node-pulse"></div>
              </div>
              <div className="node-content">
                <h4>{node.label}</h4>
                <span>{node.sub}</span>
              </div>
            </motion.div>

            {index < nodes.length - 1 && (
              <div className="tf-connector">
                <motion.div 
                  className="connector-line"
                  initial={{ width: 0 }}
                  whileInView={{ width: '100%' }}
                  viewport={{ once: true }}
                  transition={{ delay: (index * 0.2) + 0.1, duration: 0.5 }}
                />
                <motion.div 
                  className="connector-particle"
                  animate={{ 
                    x: ['0%', '100%'],
                    opacity: [0, 1, 0]
                  }}
                  transition={{ 
                    duration: 2,
                    repeat: Infinity,
                    ease: "linear",
                    delay: index * 0.5
                  }}
                >
                  <Zap size={12} fill="var(--primary)" />
                </motion.div>
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default TechFlow;
